import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class BusinessAdditionalContacts extends Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  state = {
    rows: [],
  };

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const rows = [];
    if (props.node !== undefined) {
      const executives = _.get(props.node, "executives[0].executive");
      if (executives === undefined || executives.lenght === 0) {
        rows.push(
          <Table.Row>
            <Table.Cell>No Executives Found</Table.Cell>
          </Table.Row>
        );
      } else {
        const phone = _.get(props.node, "phone[0]._", "");
        _.forEach(executives, (executive, index) => {
          const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
          rows.push(
            <Table.Row key={`Row_Executive_Name_${index}`}>
              <Table.Cell className={colorClass}>
                {getPersonName(
                  _.get(executive, "firstName[0]._", ""),
                  "",
                  _.get(executive, "lastName[0]._", ""),
                  this.props
                )}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Executive_Title_${index}`}>
              <Table.Cell className={colorClass}>
                {_.get(executive, "executiveTitle[0]._")}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`Row_Executive_Phone_${index}`}>
              <Table.Cell className={colorClass}>{phone}</Table.Cell>
            </Table.Row>
          );
        });
      }
    }
    this.state = { rows };
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Additional Contacts"}
        rows={this.state.rows}
      />
    );
  }
}

export default BusinessAdditionalContacts;



// WEBPACK FOOTER //
// ./src/components/reports/Business/BusinessAdditionalContacts.js